<template>
   
                    <div class="card vh-75" id="scroll">
                        <h3 class="m-3">Our Bids</h3>
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                     >BID DATE</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >QTY</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >PRICE</th> 
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >IDC PRICE</th>   
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >YIELD</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >COVER PRICE</th>  
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >BID RANK</th>              
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >ECN</th> 
                                    <!-- <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >STATUS</th>                      -->
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="bidwantedList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in bidwantedList" :key="data.id">
                                <td class="text-center">{{data.bidDate ? moment(data.bidDate).format("MM/DD/YYYY"): 'N/A'}}</td>
                                <td class="text-center">{{data.orderQty}}</td>
                                <td class="text-center"><span v-if="data.bidPrice">{{data.bidPrice | currency}}</span></td>
                                <td class="text-center"><span v-if="data.idcPrice">{{data.idcPrice | currency}}</span></td>
                                <td class="text-center" v-if="data.status != 'SUCCESS'">{{data.yield}}</td>
                                <td class="text-center" v-if="data.status == 'SUCCESS'">{{data.executedYield}}</td>
                                <td class="text-center">{{(data.coverPrice && data.bidRank != 2) ? data.coverPrice : ""}}</td>
                                <td class="text-center">{{ data.bidRank }}</td>
                                <td class="text-center">{{ data.ecn }}</td>
                                <!-- <td class="text-center">{{ data.status }}</td> -->
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getBidwantedList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
  name: "ourbids",
  components : {
  },
  props :["cusipId"],
  watch: { 
    cusipId: function() { // watch it
          this.getBidwantedList();
        }
      },

  data() {
    return {
        loading : false,
        status : ["BID_SENT", "ORDER_RECEIVED", "ACCEPTED","REJECTED", "SUCCESS", "HISTORY", "TRADED_AWAY","TRADE_CANCELLED","BID_CANCELLED"],
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "bidDate",
        sortOrder: "DESC",
        bidwantedList : [],
        ecn : ""
    };
  },
  methods: {
    getBidwantedList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/our-bids?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.cusipId +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.bidwantedList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
  },
  mounted() {
    this.getBidwantedList();
  }
};
</script>
